<template>
  <base-dialog width="560px" show-close :visible.sync="visible" class="start-user-dialog">
    <template v-slot:header>{{ editUserMap[operation] }}</template>
    <div>
      <div class="row">
        <div class="row-title">发起人姓名</div>
        <control-value
          v-model="extraStartUser.name"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('name', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
      <div class="row">
        <div class="row-title">发起人手机号</div>
        <control-value
          v-model="extraStartUser.telephone"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('telephone', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
      <div class="row">
        <div class="row-title">证件类型</div>
        <normal-select
          :select-list="credentials"
          :selected-item.sync="startUserInfo.type"
          class="row-body"
          size="normal"
        ></normal-select>
      </div>
      <div class="row">
        <div class="row-title">证件编号</div>
        <control-value
          v-model="extraStartUser.number"
          :control="{ _type: 'text' }"
          @input-val="setUserInfoVal('number', $event)"
          :group-list="groupList"
          class="row-body"
        ></control-value>
      </div>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { editUserMap, credentials } from "@/views/Backend/AdminEdit/Workflow/components/static"
import ControlValue from "@/components/Workflow/ControlValue"

export default {
  name: "start-user-dialog",
  components: { ControlValue, NormalSelect, BaseDialog, BaseButton },
  props: {
    operation: String,
    startUser: Object,
    extra: Object,
    groupList: Array
  },
  data() {
    return {
      editUserMap,
      credentials,
      visible: false,
      startUserInfo: {},
      extraStartUser: {
        name: null,
        telephone: null,
        number: null
      }
    }
  },
  methods: {
    open() {
      this.startUserInfo = this.startUser
      this.extraStartUser = this.extra.valueMap.startUserInfo || {}
      this.visible = true
    },
    submit() {
      if (!this.startUserInfo.name) {
        this.$message.error("发起人名称不能为空")
        return
      }
      if (!this.startUserInfo.telephone) {
        this.$message.error("发起人手机号不能为空")
        return
      }
      if (!this.startUserInfo.type) {
        this.$message.error("证件类型不能为空")
        return
      }
      if (!this.startUserInfo.number) {
        this.$message.error("证件编码不能为空")
        return
      }
      this.extra.valueMap.startUserInfo = this.extraStartUser
      this.$emit("submit", this.startUserInfo)
      this.visible = false
    },
    setUserInfoVal(attr, val) {
      this.startUserInfo[attr] = val
    }
  }
}
</script>

<style lang="scss" scoped>
.start-user-dialog {
  .el-select {
    width: 100%;
  }
  .row {
    font-size: 13px;
    padding-bottom: 15px;
    .row-title {
      font-weight: bold;
    }
    .row-body {
      margin-top: 10px;
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px;
      color: unset;
    }
  }
}
</style>
